// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// mobx
import { observer } from 'mobx-react-lite'

// fragments
import { fragments } from 'services/get-fragments'

// semantic-ui
import Container from '@mui/material/Container'

export default observer(() => (
  <Container sx={{ p: 5, '& *':{ fontSize: 'revert' } }}>
    <fragments.GettingStarted.jsx />
  </Container>
))
